module.exports = __webpack_public_path__ + "img/img_marketing_market@3x.e6b5a205.png";